import styled from 'styled-components'
import theme from 'theme_'

export const MonitoringGroupView = styled.div``

export const HeadersFrame = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  min-height: 30px;
  order: 0;
`

export const NetworkGraphContainer = styled.div``

export const MonitoringFrame = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;

  width: 50%;
  height: 32px;

  flex: none;
  order: 0;
  flex-grow: 1;
`

export const MonitoringText = styled.span`
  /* text */

  width: fit-content;
  height: 32px;
  padding-left: 2%;
  /* H2 20 */
  font-family: Montserrat;

  font-style: normal;
  font-weight: 450;
  font-size: 20px;
  line-height: 32px;
  /* identical to box height, or 160% */

  color: ${theme.colors.otterWarmBlack};

  flex: none;
  order: 0;
  flex-grow: 0;
`

export const DurationFrame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px;

  min-width: 240px;
  min-height: 40px;

  flex: none;
  order: 2;
  flex-grow: 0;
`

export const InputMaster = styled.div`
  /* 🦠 input master */
  border: none;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px;

  width: fit-content;
  height: 100%;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`

export const InputBorder = styled.div`
  /* border */

  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 0px 0px 0px;
  gap: 8px;

  width: fit-content;
  height: 100%;

  /* Primary / White */
  background: #ffffff;
  /* Dark Grey - Sec Text */
  border: 0.5px solid #a5a5a5;
  border-radius: 8px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`
